import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles, createStyles } from '@mui/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BuildIcon from '@mui/icons-material/Build';
import InsightsIcon from '@mui/icons-material/Insights';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import { Content, Page, GitHubIcon } from '@backstage/core-components';
import { PagerDutyIcon } from '@pagerduty/backstage-plugin';

import {
  HomePageStarredEntities,
  HomePageToolkit,
  FeaturedDocsCard,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { AnnouncementsCard } from '@backstage-community/plugin-announcements';

import LogoFull from '../Root/LogoFull';

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      maxWidth: '60vw',
      margin: 'auto',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '50px',
      boxShadow: theme.shadows[1],
    },
    notchedOutline: {
      borderStyle: 'none',
    },
  }),
);

export const HomePage = () => {
  const classes = useStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center">
            <Grid paddingTop={4}>
              <LogoFull />
            </Grid>
            <Grid xs={12} justifyContent="center" paddingBottom={4}>
              <HomePageSearchBar
                InputProps={{ classes }}
                placeholder="Search"
              />
            </Grid>
            <Grid container xs={12} spacing={4}>
              <Grid xs={12} md={6}>
                <AnnouncementsCard title="Announcements" max={2} />
              </Grid>
              <Grid xs={12} md={6}>
                <HomePageStarredEntities />
              </Grid>
              <Grid xs={12} md={6}>
                <FeaturedDocsCard
                  filter={[
                    {
                      'metadata.name': ['devops-central', 'observability'],
                      kind: ['component'],
                    },
                  ]}
                  subLinkText="   "
                />
              </Grid>
              <Grid xs={12} md={6}>
                <HomePageToolkit
                  tools={[
                    {
                      url: 'https://vision.imedidata.net/',
                      label: 'Vision Non-Prod',
                      icon: <InsightsIcon />,
                    },
                    {
                      url: 'https://vision.imedidata.com/',
                      label: 'Vision Prod',
                      icon: <InsightsIcon />,
                    },
                    {
                      url: 'https://mdsol.pagerduty.com/',
                      label: 'PagerDuty',
                      icon: <PagerDutyIcon />,
                    },
                    {
                      url: 'https://pikapika.imedidata.net/',
                      label: 'PikaPika (VPN)',
                      icon: <AutoAwesomeIcon />,
                    },
                    {
                      url: 'https://polybus-sandbox.imedidata.net',
                      label: 'Polybus Sandbox',
                      icon: <LiveTvIcon />,
                    },
                    {
                      url: 'https://polybus.imedidata.com',
                      label: 'Polybus Prod',
                      icon: <LiveTvIcon />,
                    },
                    {
                      url: 'https://sonarqube.imedidata.net/',
                      label: 'SonarQube',
                      icon: <RssFeedIcon />,
                    },
                    {
                      url: 'https://medistrano.imedidata.net/',
                      label: 'Medistrano (VPN)',
                      icon: <BuildIcon />,
                    },
                    {
                      url: 'https://jira.mdsol.com/',
                      label: 'Jira',
                      icon: <ViewKanbanIcon />,
                    },
                    {
                      url: 'https://github.com/mdsol/',
                      label: 'GitHub',
                      icon: <GitHubIcon />,
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
